import App from './App.svelte';
import AppKara from './kara/App.svelte';
import AppLanguages from './languages/App.svelte';
let elementsAutomatenSimulator = document.getElementsByClassName('automaten-simulator');
for (let element of elementsAutomatenSimulator) {
    let fileUrl = null;
    if (element.hasAttribute('data-datei')) {
        if (baseURL === '' && baseContentPath === '') {
            fileUrl = element.getAttribute('data-datei');
        }
        else {
            fileUrl = baseURL + '/' + baseContentPath + '/' + element.getAttribute('data-datei');
        }
        // console.log(fileUrl);
    }
    let configurationName = 'full';
    if (element.hasAttribute('data-konfiguration')) {
        configurationName = element.getAttribute('data-konfiguration');
    }
    let debug = false;
    if (element.hasAttribute('data-debug')) {
        debug = element.getAttribute('data-debug') === 'true';
    }
    let zoomToFitOnStart = false;
    if (element.hasAttribute('data-zoom-to-fit-on-start')) {
        zoomToFitOnStart = element.getAttribute('data-zoom-to-fit-on-start') === 'true';
    }
    let system = '';
    if (element.hasAttribute('data-system')) {
        system = element.getAttribute('data-system');
    }
    const app = new App({
        target: element,
        props: {
            fileUrl,
            configurationName,
            debug,
            zoomToFitOnStart,
            system,
        }
    });
}
let elementsAutomatenKara = document.getElementsByClassName('automaten-kara');
for (let element of elementsAutomatenKara) {
    const app = new AppKara({
        target: element,
        props: {}
    });
}
let elementsLanguagesAutomaton = document.getElementsByClassName('automaten-sprachen-simulator');
for (let element of elementsLanguagesAutomaton) {
    const app = new AppLanguages({
        target: element,
        props: {}
    });
}
